module.exports = __webpack_public_path__ + "static/media/kit.ba083630.png";